jQuery(document).ready(function ($) {
  $(document).on("click", ".my-collection-dropdown-toggle", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".my-collection-dropdown-toggle")
      .not($(this))
      .closest(".my-collection-dropdown")
      .removeClass("show");
    $(this).closest(".my-collection-dropdown").toggleClass("show");
  });

  $(document).on("click", ".my-collection-expand-toggle", function (e) {
    e.preventDefault();
    $(this).closest(".my-collection-expand-body").addClass("show");
  });

  $(document).on("click", ".my-collection-expand-close", function (e) {
    e.preventDefault();
    $(this).closest(".my-collection-expand-body").removeClass("show");
  });

  $(document).on(
    "click",
    ".my-collection-card-section, .my-collection-detail-close",
    function (e) {
      if (
        (e.preventDefault(),
        $("#modal_confirm_copy_btn").off("click"),
        $(".my-collection-card")
          .not($(this).closest(".my-collection-card"))
          .closest(".my-collection-card")
          .removeClass("open"),
        $(this).closest(".my-collection-card").toggleClass("open"),
        $(".my-collection-card-row").removeClass("desktop-open"),
        $(this)
          .closest(".my-collection-card-row")
          .find(".my-collection-card.open").length)
      ) {
        const e = $(this)
          .closest(".my-collection-card")
          .find(".my-collection-card-footer")
          .html();

        var div_batch_end = $(this).data("batch-end");

        $(this)
          .closest(".my-collection-card-row")
          .addClass("desktop-open")
          .find(`.my-collection-detail-content-${div_batch_end}`)
          .empty()
          .html(e);

        const t = $(this)
          .closest(".my-collection-card-row")
          .find(".my-collection-card.open .my-collection-card-header")
          .html();
        $("#confirm_copy_modal").find(".my-collection-modal-thumbnail").html(t),
          $("#confirm_delete_modal")
            .find(".my-collection-modal-thumbnail")
            .html(t),
          $("#input_copy_title").val(
            $(this).find(".my-collection-card-title").text()
          ),
          $("#copy_hidden_user_design_in").val($(this).data("user-int")),
          $("#copy_hidden_is_set").val($(this).data("isset")),
          $("#delete_hidden_user_design_in").val($(this).data("user-int")),
          $("#delete_hidden_is_set").val($(this).data("isset")),
          $(window).width() > 992 &&
            $("html, body").animate(
              {
                scrollTop: $(this).closest(".my-collection-card-row").offset()
                  .top,
              },
              500
            );
      }
    }
  ),
    $(document).on("click", function () {
      $(".my-collection-dropdown").removeClass("show");
    });

  //
  $(document).on("click", ".my-collection-card-section", function (e) {
    e.stopPropagation(); // Prevent event bubbling
    e.preventDefault(); // Prevent default action if needed

    // Check if Slick is already initialized
    if (!$(".product-rail").hasClass("slick-initialized")) {
      // Initialize Slick Slider
      $(".product-rail").slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });

  async function loginAndStoreToken(accessToken, cEmail) {
    document.querySelector('.loader-main').style.display = 'none';
    const response = await fetch(
      "https://template.abracadata.io/api/designs/generate_customer_token/",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ access_token: accessToken, email: cEmail }),
        // body: {
        //   "access_token": accessToken,
        //   "email": email
        // }
      }
    );

    const data = await response.json();

    if (data.token) {
      localStorage.setItem("user_token", data.token);
      const data_response = await fetch(
        "https://template.abracadata.io/api/designs/fetch_customer_designs/",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: data.token,
          },
        }
      );
      const dresponse = await data_response.json();
      const fullresponse = dresponse.response;
      
      if (fullresponse.length > 0) {
      
        function chunkArray(array, size) {
          return array.reduce((acc, _, i) => {
            if (i % size === 0) acc.push(array.slice(i, i + size));
            return acc;
          }, []);
        }

        const chunkedList = chunkArray(fullresponse, 3);

        $(".my-collection").empty();
        let currentBatchEnd = 3;
     
       
        chunkedList.forEach((chunk, cindex) => {
          let images_only = [];
          $(".my-collection").append(`
            <div class="cols cols-eq-height sm-cols-spacing my-collection-card-row mcard-${cindex} mb-5"></div>  
          `);
          chunk.forEach((item, index) => {
            images_only.push(item["image"]);

            $(`.mcard-${cindex}`).append(
              `
                <div class="xs-12 xsm-12 sm-12 md-4 lg-4" id="full-div-${item["coid"]}">
                  <div class="my-collection-card">
                    <div class="my-collection-card-section" data-batch-end="${currentBatchEnd}" data-isset="false" data-user-int="${item["coid"]}">
                      <div class="my-collection-card-header">
                        <div class="my-collection-card-wrapper">
                          <div class="my-collection-card-thumbnail">
                            <div class="prev-card-preview-comp">
                              <img src="${item["image"]}" width="400" height="400">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="my-collection-card-body">
                        <div class="mb-2">
                          <div class="my-collection-card-title">${item["title"]}</div>
                        </div>
                        <div class="my-collection-card-body-footer">
                          <div class="my-collection-card-updated">
                            <div class="mr-2">Bewerkt op</div>
                            <div class="ml-md-1">${item["updated_at"]}</div>
                          </div>
                          <span class="my-collection-card-toggle">
                            <i class="fa-regular fa-chevron-down fa-sm"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="my-collection-card-footer">
                      <div class="my-collection-expand">
                        <div class="my-collection-expand-header">
                          <div class="my-collection-expand-wrapper">
                            <div class="my-collection-expand-thumbnail padding-20">
                              <div class="prev-card-preview-comp">
                                <img src="${item["image"]}" width="400" height="400">
                              </div>
                            </div>
                          </div>
                          <div class="my-collection-expand-group ml-md-4">
                            <div class="mb-2 display-none display-md-block">
                              <div class="my-collection-expand-title">${item["title"]}</div>
                              <div class="my-collection-expand-updated">Bewerkt op ${item["updated_at"]}</div>
                            </div>
                            <div class="display-flex align-items-center flex-1 flex-md-0 mt-md-auto">
                              <a href="https://editor.prettyorange.nl?coid=${item["coid"]}" target="_blank" class="my-collection-btn my-collection-btn-outline mr-2">
                                <i class="fa-regular fa-pen fa-sm mr-1"></i> Bewerken
                              </a>
                              <form method="post" action="/cart/add" class="add_to_cart_${item["coid"]}">
                                <input type="hidden" name="id" value="" class="variant_id_${item["coid"]}">
                                <input type="number" name="quantity" value="1" min="1" style="display:none">
                              </form>
                              <button type="submit" class="my-collection-btn buy-now" data-coid="${item["coid"]}" data-image="${item["image"]}">
                                <i class="fa-regular fa-check fa-sm mr-1"></i> Bestellen
                              </button>
                              <div class="my-collection-dropdown">
                                <a href="#" class="my-collection-dropdown-toggle">...</a>
                                <div class="my-collection-dropdown-menu">
                                  <a class="openPrijsCalculator display-none" href="javascript:" data-card-format="single" data-card-orientation="panorama" data-main-cat="pocketfold-staand" data-has-foil="False" data-has-border="borderStraight" data-minimum-quantity="5" data-special-material="" data-user-design-id="${item["coid"]}">
                                    <i class="fa-regular fa-euro-sign"></i> <span> Bereken jouw prijs </span>
                                  </a>
                                  <a class="delete-collection remove_design" data-coid="${item["coid"]}" data-toggle="tooltip" title="Verwijderen">
                                    <i class="fa-regular fa-trash fs-6"></i> <span class="ms-1">Verwijderen</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                `
            );
            // Insert the "my-collection-detail" div after every 3 items
            if ((index + 1) % 3 === 0 || index + 1 == chunk.length) {
              $(`.mcard-${cindex}`).append(
                `
                    <div class="xs-12 xsm-12 sm-12 md-12 lg-12 my-collection-detail detail-${currentBatchEnd}">
                      <a href="#" class="my-collection-detail-close"> <i class="fa-regular fa-xmark"></i> </a>
                      <div class="my-collection-detail-content-${currentBatchEnd}">
                        <div class="my-collection-expand">
                          <div class="my-collection-expand-header">
                            <div class="my-collection-expand-wrapper">
                              <div class="my-collection-expand-thumbnail padding-20">
                                <div class="prev-card-preview-comp">
                                  <sp-card-preview
                                    responsive="true"
                                    scale-percentage="0"
                                    card-images="${images_only}"
                                    card-fold="vertical"
                                    card-show-glow="false"
                                    card-rounded-corners="0"
                                    card-drop-shadow-size="2"
                                    card-drop-shadow-brightness="0.2"
                                    view="front"
                                    class="hydrated"
                                    style="display: block; width: 100%; height: 100%;"
                                  ></sp-card-preview>
                                </div>
                              </div>
                            </div>
                            <div class="my-collection-expand-group ml-md-4">
                              <div class="mb-2 display-none display-md-block">
                                <div class="my-collection-expand-title">Kaartenset - Boog + halve boog</div>
                                <div class="my-collection-expand-updated">Bewerkt op 27-01-2025, 18:14</div>
                              </div>
                              <div class="display-flex align-items-center flex-1 flex-md-0 mt-md-auto">
                                <a href="https://editor.prettyorange.nl?coid=" target="_blank" class="my-collection-btn my-collection-btn-outline mr-2">
                                  <i class="fa-regular fa-pen fa-sm mr-1"></i> Bewerken
                                </a>
                                <a href="/choose_user_card/?user_design_id=8263774&amp;target_url=customize" class="my-collection-btn">
                                  <i class="fa-regular fa-check fa-sm mr-1"></i> Bestellen
                                </a>
                                <div class="my-collection-dropdown">
                                  <a href="#" class="my-collection-dropdown-toggle">...</a>
                                  <div class="my-collection-dropdown-menu">
                                    <a class="openPrijsCalculator display-none" href="javascript:" data-card-format="single" data-card-orientation="square" data-main-cat="labelkaart-m" data-has-foil="False" data-has-border="borderStraight" data-minimum-quantity="5" data-special-material="" data-user-design-id="8263774">
                                      <i class="fa-regular fa-euro-sign"></i> <span> Bereken jouw prijs </span>
                                    </a>
                                    <a class="delete-collection" data-toggle="tooltip" data-coid="${item["coid"]}" title="Verwijderen" data-bs-toggle="modal" data-bs-target="#confirm_delete_modal" href="#" rel="nofollow">
                                      <i class="fa-regular fa-trash fs-6"></i> <span class="ms-1">Verwijderen</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="my-collection-expand-body show">
                              <a href="#" class="my-collection-expand-toggle"> Toon producten op basis van dit ontwerp </a>
                              <div class="my-collection-expand-menu">
                                <div class="display-flex justify-content-between align-items-center flex-wrap mb-4">
                                  <span class="my-collection-expand-title"> Passend bij dit ontwerp </span>
                                  <a class="my-collection-expand-close" href="#">
                                    <i class="fa-regular fa-xmark"></i> <span> Verbergen </span>
                                  </a>
                                </div>
                                <div id="product-rail"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    `
              );
              images_only = [];
              currentBatchEnd += 3;
            }
          });
        });
    
        async function buyNow(coid, image) {
          const variantid_resp = await fetch(
            "https://template.abracadata.io/api/designs/fetch_variation_id/" +
              coid +
              "/",
            {
              method: "GET",
            }
          );
          var variantJSON = await variantid_resp.json();

          var variant_id = variantJSON["variant_id"];
          $(`.variant_id_${coid}`).val(variant_id);

          const form = document.querySelector(`.add_to_cart_${coid}`);
          const formData = new FormData(form);

          formData.append("properties[custom_image]", image);
          formData.append("properties[coid]", coid);
          fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            // Redirect to checkout page
            window.location.href = "/checkout";
          })
          .catch((error) => {
            console.error(
              'There was a problem with the "Buy Now" request:',
              error
            );
          });
        }

        $(document).on("click", ".buy-now", function () {
          var coid = $(this).data("coid");
          var image = $(this).data("image");
          buyNow(coid, image);
        });
      }else{
         $(".my-collection").append(`
            <div class="data-not-found">Geen eigen ontwerpen</div>  
          `);

      }
    }
  }

  let access_token = "";
  async function generate_django_token() {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      const maxAttempts = 10; // Set a reasonable retry limit
      const intervalTime = 1000; // 1 second interval

      const interval = setInterval(async () => {
        if (
          ShopifyAnalytics &&
          ShopifyAnalytics.lib &&
          ShopifyAnalytics.lib.user
        ) {
          const user = ShopifyAnalytics.lib.user();
          if (user && user.traits && typeof user.traits === "function") {
            const access_token = user.traits().uniqToken;
            if (access_token) {
              clearInterval(interval);
              let email = "";
              await fetch("/account")
                .then((response) => response.text())
                .then((html) => {
                  let parser = new DOMParser();
                  let doc = parser.parseFromString(html, "text/html");
                  let userElement = doc.querySelector(".user-email");
                  let splited_text = userElement.textContent.split(" ");

                  email = splited_text[splited_text.length - 1];
                });

              loginAndStoreToken(access_token, email); // Assuming email is also needed
              resolve(access_token);
            }
          }
        }

        attempts++;
        if (attempts >= maxAttempts) {
          clearInterval(interval);
          //console.error("Failed to load access token after multiple attempts.");
          reject(new Error("Access token not available"));
        }
      }, intervalTime);
    });
  }

  generate_django_token();

let deleteCOID = null; 
let selectedElement = null;

// OPEN POPUP
$(document).on("click", ".remove_design", function(e){
    e.preventDefault();

    deleteCOID = $(this).data("coid");
    selectedElement = $(this).closest(".my-collection-expand"); // Card container to remove

    // Get image & title
    let image = $(this).closest(".my-collection-expand").find("img").attr("src");
    let title = $(this).closest(".my-collection-expand").find(".my-collection-expand-title").text();

    $("#deletePopupImage").attr("src", image);
    $("#deletePopupTitle").text(title);

    $(".delete-popup-overlay").fadeIn(200);
});

// CONFIRM DELETE
$("#confirmDelete").on("click", async function(){

    var user_token = localStorage.getItem("user_token");

    const delete_response = await fetch(
      "https://template.abracadata.io/api/designs/remove_customer_design/?coid=" + deleteCOID,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": user_token
        }
      }
    );

    const design_response = await delete_response.json();

    if(delete_response.ok){
      // Remove card from DOM
      $(selectedElement).remove();
      $(".my-collection-card-row").removeClass("desktop-open");
    }

    $(".delete-popup-overlay").fadeOut(200);

    location.reload();
  });
});

// Close Modal
$(document).on("click", ".close-modal", function () {
  $(".delete-popup-overlay").fadeOut(200);
});

// Close Modal On OUTSIDE Click
$(document).on("click", ".delete-popup-overlay", function (e) { 
  if ($(e.target).closest(".modal-content").length === 0) {
    $(".delete-popup-overlay").fadeOut(200);
  }
});